export function getExpiredYearOptions() {
  const currentYear = new Date().getFullYear();
  const expiredYearOption = [];
  for (let i = 0; i < 10; i++) {
    expiredYearOption.push({
      value: currentYear + i,
      display: (currentYear + i).toString(),
    });
  }
  return expiredYearOption;
}
